<template lang='pug'>
v-card(class='with-pointer mh100 flex-card')
  div(class="object-state" :class="[object.status_id, { published: object.published == 1} ]" )
    | {{ objectStateName }}
  div(@click='$emit("click", object)')

    v-card-title(primary-title)
      v-flex(d-block pa-0)
        div(class='grey--text') {{ object.object_type_name || '&nbsp;' }}
        h3(class='headline mb-0 text-truncate')
          | {{ object.object_name || '&nbsp;' }}
        div(v-if='object.address' class='my-1 pa-0')
          div(class='grey--text') Адрес
          div(class='text-truncate') {{ object.address }}
        div(v-if='object.dvizh_uuid')
          | {{'ДВИЖ UUID: ' + object.dvizh_uuid}}
    meta-data(
      v-if='object.object_info'
      :object='object.object_info'
      :date='object.due_date'
    )
  v-card-actions
    v-spacer
    v-btn(@click.stop='$emit("btilayouts", object)' flat small) БТИ планы
    v-btn(@click.stop='$emit("remove", object)' flat small) Удалить
    v-btn(@click.stop='$emit("edit", object)' flat small) Редактировать
</template>

<script>
import MetaData from './MetaData'
export default {
  props: ['object'],
  components: {
    MetaData
  },
  computed: {
    objectStateName() {
      if(this.object.status_id=='sold') return 'Продан'
      if(this.object.status_id=='on_sale') return 'В продаже'
      if(this.object.status_id=='draft') return 'Черновик'
      if(this.object.status_id=='stopped') return 'Приостановлено'
      if(this.object.status_id=='soon') return 'Скоро в продаже'
      return 'Созидание'
    }
  }
}
</script>

<style scoped>

.object-state {
  padding: 3px 15px;
  display: block;
  flex: none !important;
}


.object-state.published {
  background-color: #27ae60 ;
  color: white;
}

.object-state.stopped {
  background-color: #ff0000 ;
  color: white;
}


.object-state.sold {
  background-color: #ffac11 ;
  color: white;
}

.object-state.draft {
  background-color: #c4c4c4 ;
  color: white;
}


</style>
